import React from "react";
import { Link } from "react-router-dom";
import { useOrganization } from "../../../context/OrganizationContext";
import { usePermissions } from "../../../context/PermissionsContext";
import { useOrganizationFeatures } from "../../../context/OrganizationFeaturesContext";
import InlineAlert from "../../UI/DesignStandards/Notifications/InlineAlert";
import { SkeletonBoard } from "../../UI/DesignStandards";
import {
  AVERAGE_IMPORT_PLAN_MESSAGE,
  FEATURE_AI_LEAGUE_AVERAGE_IMPORT,
} from "../../../utility/features";

const PERMISSION_DENIED_MESSAGE =
  "Your role does not include manage tournaments.";

const AverageCatalogsGate = ({ children }) => {
  const { loading: organizationLoading } = useOrganization();
  const { canManageTournaments } = usePermissions();
  const { hasFeature, ready: grantsReady } = useOrganizationFeatures();

  // Roles arrive with the organization fetch. Grants resolve after that.
  // Neither "still loading" state is a confirmed denial.
  const roleKnown = !organizationLoading;
  const grantsKnown = grantsReady;

  if (!roleKnown || !grantsKnown) {
    return (
      <div
        className="space-y-4 sm:space-y-6"
        role="status"
        aria-label="Loading average catalogs"
      >
        <SkeletonBoard rows={2} />
      </div>
    );
  }

  const missingGrant = !hasFeature(FEATURE_AI_LEAGUE_AVERAGE_IMPORT);
  const missingPermission = !canManageTournaments;

  if (!missingGrant && !missingPermission) {
    return children;
  }

  return (
    <div className="space-y-4">
      {missingGrant ? (
        <div className="space-y-2">
          <InlineAlert
            type="info"
            title="Average catalogs is not available"
            message={AVERAGE_IMPORT_PLAN_MESSAGE}
          />
          <Link
            to="/organization/plan"
            className="inline-block text-sm underline text-brand-gold-ink"
          >
            Open Plan
          </Link>
        </div>
      ) : null}
      {missingPermission ? (
        <InlineAlert
          type="info"
          title="You cannot open Average catalogs"
          message={PERMISSION_DENIED_MESSAGE}
        />
      ) : null}
    </div>
  );
};

export default AverageCatalogsGate;
